module.exports = __webpack_public_path__ + "static/media/FlyOut-star@3x.8cfeadf0.png";